/**
 * Pulls the HTTP status off a rejected request. The request layer rewraps
 * failures into ky `HTTPError`s, so the status always hangs off `response`.
 */
export const getErrorStatus = (error: unknown): number | undefined => {
  if (typeof error !== 'object' || error === null) return undefined

  const { response } = error as { response?: unknown }
  if (typeof response !== 'object' || response === null) return undefined

  const { status } = response as { status?: unknown }
  return typeof status === 'number' ? status : undefined
}

/**
 * A 404 from an alert endpoint means the backend no longer has the alert —
 * the list on screen is stale. Callers act on that rather than reporting a
 * generic failure the user can only respond to by retrying forever.
 */
export const isAlertMissingError = (error: unknown): boolean => getErrorStatus(error) === 404
